import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ResponsiveComponent } from '../shared/responsive/responsive.component';
import { Activity } from '../../core/activity/activity';
import { MediaQueryService } from '../shared/responsive/services/media-query.service';
import { dateToLocalDate } from '../shared/common';


@Component({
  selector: 'app-weblink-activity-view',
  templateUrl: './weblink-activity-view.component.html',
  styleUrls: ['./weblink-activity-view.component.scss']
})
export class WeblinkActivityViewComponent extends ResponsiveComponent implements OnInit {

  @Input()
  activity: Activity;
  @Output()
  closeDialog = new EventEmitter();

  constructor(mediaQueryService: MediaQueryService ) {
    super(mediaQueryService);
  }

  ngOnInit() {
  }

  public close(){
    this.closeDialog.emit();
  }

  public get statusText():string{

    return this.activity? this.activity.Status.Name1 + " - " +  this.activity.Status.Name2: null;

  }
  public set statusText(text:string){
  }

  public get statusDate():string{
    return dateToLocalDate(this.activity.Date.toString());
  }
  public set statusDate(date:string){
  }



}
